import {Box, Typography} from "@mui/material"
import React from "react"

function NoActivities({children}: {children: React.ReactNode}) {
	return (
		<Box display="flex" justifyContent="center" alignItems="center">
			<Typography variant="h5" color="textSecondary">
				{children}
			</Typography>
		</Box>
	)
}

export {NoActivities}
